import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Select from 'react-select';

import nigeria from "../assets/images/nigerian-logo.png";
import uganda from "../assets/images/uganda.png";
import kenya from "../assets/images/kenya.png";
import cameroon from "../assets/images/cameroon.png";
import canada from "../assets/images/canada.png";
import uae from "../assets/images/uae.png";
import exchangesign from "../assets/images/Group 2663.png";
import infoIcon from "../assets/images/warning.png";
import currency from "../assets/images/ri_currency-fill.png";
import sendIcon from "../assets/images/lets-icons_send-fill.png";
import chartIcon from "../assets/images/ic_baseline-ssid-chart.png";
import alertIcon from "../assets/images/fluent_alert-16-regular.png";
import { NavLink } from 'react-router-dom';

// select country options 
const currencies = [
    {
        value: "NGN",
        label: (
            <div className="flex items-center gap-2 text-[.7rem]">
                <img src={nigeria} alt="NGN" className="w-4 h-4 rounded-full" />
                <span>NGN - Nigerian Naira</span>
            </div>
        ),
    },
    {
        value: "UGX",
        label: (
            <div className="flex items-center gap-2 text-[0.7rem]">
                <img src={uganda} alt="UGX" className="w-4 h-4 rounded-full" />
                <span>UGX - Ugandan Shilling</span>
            </div>
        ),
    },
];

export default function FastestExchange() {
    const [amount, setAmount] = useState("");
    const [fromCurrency, setFromCurrency] = useState(currencies[0]);
    const [toCurrency, setToCurrency] = useState(currencies[1]);

    return (
        <motion.div
            className="inner_bg bg-cover bg-center py-[3%] px-[10%]"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 0.8, ease: "easeOut" }}
        >
            <div className="flex flex-wrap md:flex-nowrap gap-6">

                {/* Left Side Text */}
                <motion.div
                    className="w-full md:w-1/2 py-4"
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                   <div>
                   <h1 className="px-6 pt-6 text-[2.5rem] md:text-[3.5rem] font-extrabold leading-none text-[var(--primary-color)]">
                        Fastest <br /> Exchange <br />
                        for <span className="relative text-[var(--second-primary-color)]">You.</span>
                    </h1>
                   </div>
                   <div>
                   <p className="pt-8 px-6 text-[#93969d] font-[400] text-[1rem] md:text-[.9rem]">
                        Send Money Instantly, Buy and Sell USDT <br />& Bitcoin with Fastest
                    </p>
                   </div>

                    {/* Countries List */}
                    <motion.div
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ type: "spring", stiffness: 60, damping: 7, delay: 0.2 }}
                    viewport={{ once: false, amount: 0.2 }} 
                    className="pl-6 pr-20  pt-8 text-black text-[.6rem] font-[600]">
                        <p className="py-2 font-[800] text-[1.2rem]">Popular Countries We Send Money</p>
                        <div className="grid grid-cols-3 gap-y-3">
                            {[{ name: 'Nigeria', flag: nigeria },
                            { name: 'Cameroon', flag: cameroon },
                            { name: 'Uganda', flag: uganda },
                            { name: 'Canada', flag: canada },
                            { name: 'Kenya', flag: kenya },
                            { name: 'UAE', flag: uae }].map(({ name, flag }) => (
                                <div key={name} className="flex items-center">
                                    <img className="w-[22px] pt-2" src={flag} alt={`${name} logo`} />
                                    <span className="pt-2 text-sm px-2">{name}</span>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </motion.div>

                {/* Right Side Card */}
                <motion.div
                    className="w-full md:w-1/2 flex justify-center items-center bg-[url('/image/fastest-logo.png')] bg-contain bg-top bg-no-repeat"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <div className="relative bg-white/40 backdrop-blur-md mt-8 rounded-md shadow-lg w-full max-w-md">
                        {/* Top Nav Icons */}
                        <div className="grid grid-cols-4 gap-3 bg-[#ebf8fd] text-[.9rem] rounded-t font-[500] text-[#27346A] mb-4">
                            <div className="flex items-center p-3 rounded-tl shadow-[0_-1px_6px_-1px_rgba(0,0,1,0.1)] backdrop-blur-md bg-white/90 text-[#D71E7E]">
                                <img className="w-4 h-4" src={currency} alt="currency" />
                                <span className="ml-1">Convert</span>
                            </div>
                            <div className="flex items-center">
                                <img className="w-4 h-4" src={sendIcon} alt="send" />
                                <span className="ml-1">Send</span>
                            </div>
                            <div className="flex items-center">
                                <img className="w-4 h-4" src={chartIcon} alt="chart" />
                                <span className="ml-1">Charts</span>
                            </div>
                            <div className="flex items-center">
                                <img className="w-4 h-4" src={alertIcon} alt="alert" />
                                <span className="ml-1">Alerts</span>
                            </div>
                        </div>

                        {/* Form Start */}
                        <form action="" onSubmit={(e) => e.preventDefault()} className='px-6 pt-3 pb-6'>
                            <div className="mb-3">
                                <label className="text-[0.9rem] text-[#555D68] mb-1 block">You are sending</label>
                                <div className="flex items-center">
                                    <input
                                        type="number"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)}
                                        className="border rounded-l border-[#DBDBDB] w-[80%] px-2 py-[10px] focus:outline-none focus:ring-1 focus:ring-blue-400 shadow-sm text-sm"
                                        placeholder="0"
                                    />
                                    <div className="flex items-center gap-1 w-[20%] justify-center rounded-r border border-[#DBDBDB] bg-white px-1 py-[10px] text-[.7rem]">
                                        <img className="w-5 h-5" src={nigeria} alt="Naira" />
                                        <span>NGN</span>
                                    </div>
                                </div>
                            </div>

                            {/* From Currency */}
                            <div className="w-full max-w-md mx-auto">
                                <label className="text-[0.9rem] text-gray-400 mb-1 block">From</label>
                                <Select
                                    options={currencies}
                                    defaultValue={currencies[0]}
                                    value={fromCurrency}
                                    onChange={(selectedOption) => setFromCurrency(selectedOption)}
                                    className="text-sm"
                                    classNamePrefix="react-select"
                                    isSearchable={true}
                                />
                            </div>

                             {/* Exchange symbol  */}
                            <div className="flex justify-center my-">
                                <img src={exchangesign} alt="exchange" className="w-7" />
                            </div> 

                            {/* To Currency */}
                            <div className="w-full max-w-md mx-auto relative -top-5">
                                <label className="text-[0.9rem] text-gray-400 mb-1 block">To</label>
                                <Select
                                    options={currencies}
                                    defaultValue={currencies[1]}
                                    value={toCurrency}
                                    onChange={(selectedOption) => setToCurrency(selectedOption)}
                                    className="text-sm"
                                    classNamePrefix="react-select"
                                    isSearchable={true}
                                />
                            </div>

                            <div>
                                <NavLink to="https://app.fastest.exchange/login"  className="text-[.9rem] block text-center font-bold py-[9px] px-6 w-full mb-4 bg-[var(--primary-color)] text-[#2AD5FF] rounded-md hover:bg-blue-900 transition duration-200">
                                Get Started
                            </NavLink>
                            </div>

                            <div className="flex items-start text-[#555D68] text-[.8rem] gap-2">
                                <img className="w-4 h-4 mt-2" src={infoIcon} alt="info" />
                                <span>
                                    We utilize the mid-market rate which is intended for informational purposes only. Please note that this rate will not be applied when sending money.
                                </span>
                            </div>

                        </form>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
}
